import TwitterDashboardView from "src/sections/dashboards/platforms/twitter/twitter-dashboard-view";

const TwitterCustomDashboardPage = () => <TwitterDashboardView type="custom" />;

export default TwitterCustomDashboardPage;
